import EventAgent from '@hotmart/event-agent-js';
import { DataHubEntities } from './dataHubEntities';
import { DataHubSystems } from './dataHubSystems';
EventAgent.mode = process.env.TARGET_ENV === 'production' ? 'production' : 'staging';
class DataHubService {
    static sendEvent({ schema, dataVersion = '1.0', system = DataHubSystems.HotmartClub, entity = DataHubEntities.Admin }) {
        const dataHubEvent = {
            system,
            entity,
            action: schema.action,
            data_version: dataVersion,
            event: schema.getDataHubEventData()
        };
        if (process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line no-console
            console.log('Datahub event dispatched: ', dataHubEvent);
        }
        EventAgent.send(dataHubEvent);
    }
}
export default DataHubService;
